import { Service } from "@roc/feature-app-core";

export const url = {
  GET_ALL_POSSIBLE_TERM_TIER_BORROWERS: '/api/v1/lender/submissionPricingTiers/getPossibleTermTiersBorrowers',
  SAVE_TERM_TIER: '/api/v1/lender/submissionPricingTiers/saveSubmissionPricingTiers',
  GET_ALL_TERM_TIERS: '/api/v1/lender/submissionPricingTiers/getAllSubmissionPricingTiersByLenderId',
  DELETE_TERM_TIER: '/api/v1/lender/submissionPricingTiers/deleteTermTier',
  DELETE_BORROWER_FROM_TERM_TIER: '/api/v1/lender/submissionPricingTiers/deleteBorrowerFromTermTier',
  UPDATE_TERM_TIER: '/api/v1/lender/submissionPricingTiers/updateTermTier',
  MOVE_BORROWER_TO_NEW_TERM_TIER: '/api/v1/lender/submissionPricingTiers/moveBorrowerToNewTier',
  GET_ALL_POSSIBLE_OR_MATCHING_TERM_TIER_BORROWERS: '/api/v1/lender/submissionPricingTiers/getAllPossibleOrMatchingTierBorrowers',
  ADD_REMOVE_BORROWER_FROM_TIER: '/api/v1/lender/submissionPricingTiers/addRemoveBorrowerFromTier'
};
export class LenderTermTierEconomicsService extends Service {


  getAllTermTierUsers(pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string) {
    return this.get(url.GET_ALL_POSSIBLE_TERM_TIER_BORROWERS,
      { pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters },
      { disableGlobalLoading: true }
    );
  }

  saveTermTier(data) {
    return this.post(url.SAVE_TERM_TIER, data);
  }

  updateTermTier(data) {
    return this.patch(url.UPDATE_TERM_TIER, data);
  }

  getAllTermTiers(lenderId) {
    return this.get(`${url.GET_ALL_TERM_TIERS}?lenderId=${lenderId}`);
  }

  deleteTermTier(tierId) {
    return this.delete(`${url.DELETE_TERM_TIER}?tierId=${tierId}`);
  }

  deleteBorrowerFromTier(tierId, borrowerId) {
    return this.delete(`${url.DELETE_BORROWER_FROM_TERM_TIER}?tierId=${tierId}&borrowerId=${borrowerId}`);
  }

  moveBorrowerToNewTermTier(oldTierId, borrowerId, newTierId) {
    return this.patch(`${url.MOVE_BORROWER_TO_NEW_TERM_TIER}?oldTierId=${oldTierId}&borrowerId=${borrowerId}&newTierId=${newTierId}`, {});
  }

  getAllPossibleOrMatchingTierBorrowers(pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string, tierId: Number) {
    return this.get(url.GET_ALL_POSSIBLE_OR_MATCHING_TERM_TIER_BORROWERS,
      { pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters, tierId },
      { disableGlobalLoading: true }
    );
  }

  addRemoveBorrowers(data) {
    return this.patch(`${url.ADD_REMOVE_BORROWER_FROM_TIER}`, data);
  }

}